// extracted by mini-css-extract-plugin
export default {"hubName":"hubName___xevLM","hubNoticeNumber":"hubNoticeNumber___ngK0x"};